import { Typography } from '@mui/material'
import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { InfoContainer } from '../shared/InfoContainer'

export const DOTNumberDetails = memo(() => {
  return (
    <Fragment>
      <Typography css={tw`mt-2 !mb-2`} variant="h2">
        Upload a USDOT or DOT Number
      </Typography>
      <Typography css={tw`mb-2 text-shades-400`}>
        Choose the document that applies to you.
      </Typography>

      <div css={tw`mt-6 text-base`}>
        <Typography css={tw`text-shades-400 text-xs font-bold uppercase`} variant="overline">
          USDOT & DOT DETAILS
        </Typography>

        <div css={tw`bg-shades-0 p-4 rounded-2xl mt-2 mb-4`}>
          <div css={tw`mb-4`}>
            <Typography css={tw`font-bold text-black mb-1`} variant="body1">
              USDOT Number (most common)
            </Typography>
            <Typography css={tw`text-shades-400`} variant="body1">
              If you operate across state lines or your vehicle is over 10,000 lbs, upload your
              FMCSA-issued USDOT number.
            </Typography>
          </div>

          <div css={tw`mb-4`}>
            <Typography css={tw`font-bold text-black mb-1`} variant="body1">
              State DOT Number (intrastate carriers only)
            </Typography>
            <Typography css={tw`text-shades-400`} variant="body1">
              If you operate only within one state and your state requires a DOT number (e.g.,
              TXDOT, MDOT, CA Number), upload your state-issued DOT number.
            </Typography>
          </div>

          <InfoContainer color="orange">
            <span css={tw`font-bold`}>Not sure which one you have?</span>
            <span css={tw`mt-2 block`}>
              Your USDOT number will appear in FMCSA records. State DOT numbers come from your
              state's transportation authority.
            </span>
          </InfoContainer>
        </div>
      </div>
    </Fragment>
  )
})
